<div class="thumb-bg-img">
  <img [businessImage]="imageSrc" [businessImagePending]="true" [alt]="slideText || 'Photo category'" loading="lazy" decoding="async" (businessImageError)="imageError.emit($event)" />
  <span class="text">{{slideText}}</span>
</div>
